import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Section } from "@/components/common";
import { CheckCircle2, XCircle } from "lucide-react";

export default function Confirm() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.get(`/newsletter/confirm?token=${token}`).then(() => setState("ok")).catch(() => setState("error"));
  }, [params]);

  return (
    <Section className="py-24 max-w-lg text-center">
      <div className="card p-10" data-testid="confirm-result">
        {state === "loading" && <p className="text-slate-400 font-mono">Confirming…</p>}
        {state === "ok" && (<>
          <CheckCircle2 className="text-[#84CC16] mx-auto mb-4" size={44} />
          <h1 className="font-display font-bold text-2xl text-white">Subscription confirmed</h1>
          <p className="text-slate-400 mt-2">You'll receive the weekly newsletter. Thanks for choosing to Do Your Own Research.</p>
          <Link to="/" className="inline-block mt-6 bg-[#2563EB] hover:bg-[#3B82F6] text-white font-semibold px-5 py-2.5 rounded-lg">Back to home</Link>
        </>)}
        {state === "error" && (<>
          <XCircle className="text-red-400 mx-auto mb-4" size={44} />
          <h1 className="font-display font-bold text-2xl text-white">Invalid or expired link</h1>
          <p className="text-slate-400 mt-2">Please sign up again to receive a fresh confirmation email.</p>
          <Link to="/newsletter" className="inline-block mt-6 bg-[#2563EB] hover:bg-[#3B82F6] text-white font-semibold px-5 py-2.5 rounded-lg">Sign up</Link>
        </>)}
      </div>
    </Section>
  );
}
